/**
 * Returns a date shifted with the number of days as specified in parameter
 *
 * @param days - The days the current date needs to be shifted with
 * @returns Expiry date
 */
export const getExpiryDate = (days: number): Date => {
    const date = new Date();

    date.setDate(date.getDate() + days);

    return date;
};
